<template>
  <v-col class="shadow">
    <!-- Ticket shape -->
    <svg class="svg">
      <clipPath id="my-clip-path" clipPathUnits="objectBoundingBox">
        <path
          d="M0.007,0.989 l-0.007,-0.013,0,-0.154,0.001,-0.154,0.009,-0.002 c0.037,-0.007,0.07,-0.054,0.082,-0.117 c0.02,-0.105,-0.02,-0.219,-0.082,-0.23 l-0.009,-0.002,0,-0.146,0,-0.147,0.006,-0.011,0.006,-0.011,0.487,0,0.487,0,0.006,0.011,0.006,0.011,0.001,0.476,0,0.476,-0.006,0.012,-0.007,0.012,-0.486,0.001,-0.486,0.001,-0.007,-0.013"
        />
      </clipPath>
    </svg>

    <!-- Content -->
    <div class="clipped">
      <v-container class="no-scroll pl-md-5" align="center" fill-height>
        <v-row class="ma-0">
          <v-col cols="12" class="pl-md-5 pt-0 mt-0">
            <v-row class="ma-0">
              <!-- Image -->
              <v-col
                cols="12"
                md="3"
                class="hidden-sm-and-down"
                align-self="center"
              >
                <v-avatar size="100">
                  <v-img v-if="activity.picture" :src="activity.picture" />
                  <v-icon v-else x-large>image</v-icon>
                </v-avatar>
              </v-col>

              <!-- Details -->
              <v-col cols="12" md="6" justify="center" fill-height>
                <h3 class="pb-5">{{ activity.name }}</h3>

                <section class="pb-5">
                  <div>{{ $translate('TIME') }}</div>
                  <h4>{{ activity.time }}</h4>
                </section>

                <section>
                  <div>{{ $translate('ORDERID') }}</div>
                  <h4>{{ activity.orderId }}</h4>
                </section>
              </v-col>

              <!-- Date -->
              <v-col cols="12" md="3">
                <h4 class="center-text">
                  {{ activity.date.split('-')[0] }}
                  {{ activity.month }}
                  {{ activity.date.split('-')[2] }}
                </h4>
              </v-col>
            </v-row>

            <v-divider class="mt-1" />

            <!-- Activity Buttons -->
            <v-row
              class="ma-0 mt-3"
              justify="center"
              justify-md="space-between"
            >
              <v-btn text class="text-capitalize" @click="getOrderBinaryData">
                <v-icon color="black" small left>credit_card</v-icon>
                {{ $translate('GET_TICKETS') }}
              </v-btn>

              <v-btn text class="text-capitalize" @click="dialog = true">
                <v-icon color="black" small left>delete</v-icon>
                {{ $translate('CANCEL_ACTIVITY') }}
              </v-btn>
            </v-row>

            <!--  History Review -->
            <v-btn
              class="mt-3 text-capitalize"
              text
              v-if="!activity.reviewed"
              @click="showReviewBox = !showReviewBox"
            >
              <v-icon color="black" left>rate_review</v-icon>
              {{ $translate('LEAVE_A_REVIEW') }}
            </v-btn>
            <v-row v-else justify="center">
              <v-icon color="green" left>check</v-icon>
              <p class="text--disabled mt-5">
                {{ $translate('REVIEWED') }}
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Review box -->
    <v-card class="d-inline-block mx-auto full-width mt-1" v-if="showReviewBox">
      <v-container class="no-scroll pl-5 pr-5">
        <v-row class="pl-5" align="center">
          <v-rating
            v-model="rating"
            full-icon="star"
            empty-icon="star_outline"
            background-color="grey"
            color="orange"
            medium
            required
            class="mb-2 mt-2"
          />
          <p class="error-text mt-4 ml-2" v-if="reviewError">
            {{ $translate('PICK_A_RATING') }}
          </p>
          <v-spacer />
          <v-btn
            color="blue"
            class="mt-3 text-capitalize"
            text
            @click="addReview"
          >
            {{ $translate('SUBMIT') }}
          </v-btn>
        </v-row>
        <v-row justify="space-between" class="pl-5 pr-5">
          <v-textarea
            outlined
            name="input-7-4"
            :label="$translate('REVIEW')"
            v-model="review"
          ></v-textarea>
        </v-row>
      </v-container>
    </v-card>

    <!-- Delete dialog -->
    <v-dialog max-width="480" v-model="dialog">
      <v-card>
        <v-card-title class="headline">
          {{ $translate('DELETE_ACTIVITY') }} {{ activity.name }}
        </v-card-title>

        <v-card-text>{{ $translate('SURE_CANCEL_ACTIVITY') }}</v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" text @click="dialog = false">
            {{ $translate('NO') }}
          </v-btn>

          <v-btn color="green darken-1" text @click="cancelActivity">
            {{ $translate('YES') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import doRequest from '@/api/dssRequest';

export default {
  data() {
    return {
      rating: 0,
      review: '',
      history: false,
      showReviewBox: false,
      reviewError: false,
      dialog: false,
      title: 'binder',
      pdf: '',
      dialogData: {
        title: 'test test?',
        message: 'testers',
        confirmText: 'OK',
        cancelText: 'Cancel',
        confirmFunction: {},
      },
    };
  },
  name: 'ActivityTicket',
  props: ['activity'],
  watch: {},
  computed: {},
  created() {
    window.EventBus.listen('activitiesToggle', this.hideReviewBox);
  },
  methods: {
    hideReviewBox() {
      this.showReviewBox = false;
      // console.log("TOGGLE LISTEN")
    },
    getOrderBinaryData() {
      const payload = {
        Id: this.activity.orderId,
      };
      doRequest(
        (response) => {
          // to download the pdf
          const source = 'data:application/pdf;base64,' + response.data.Data;
          console.log(source);
          const downloadLink = document.createElement('a');
          const fileName = 'order_' + this.activity.orderId + '.pdf';
          downloadLink.href = source;
          downloadLink.download = fileName;
          downloadLink.click();
          // to open the pdf in a new window
          let pdfWindow = window.open('');
          setTimeout(() => {
            pdfWindow.document.write(
              "<iframe width='100%' name='text' height='100%' src='" +
                source +
                "'></iframe>"
            );
            pdfWindow.document.title = fileName;
          }, 0);
        },
        (error) => {
          // Handle error if needed
        },
        'getOrderBinaryData',
        'LocationsNode_OSE',
        payload
      );
    },
    cancelActivity() {
      console.log('cancel Activity ', this.activity.name);
      this.dialog = false;
      const payload = {
        UniqueId: this.activity.activityId,
      };
      doRequest(
        (response) => {
          this.$emit('reload');
        },
        (error) => {},
        'cancelBooking',
        this.$store.getters['auth/userName'],
        payload
      );
    },
    addReview() {
      if (this.rating == 0) {
        console.log('rate higher than 0');
        this.reviewError = true;
      } else {
        this.reviewError = false;
        const payload = {
          Name:
            this.$store.getters['auth/user'].firstName !== ''
              ? this.$store.getters['auth/user'].firstName +
                ' ' +
                this.$store.getters['auth/user'].lastName
              : this.$store.getters['auth/user'].email,
          Rating: this.rating,
          Review: this.review,
        };
        doRequest(
          (response) => {
            this.markActivityAsReviewed();
          },
          (error) => {},
          'addReview',
          this.activity.eventId,
          payload,
          'POST',
          600000,
          false
        );
      }
    },
    markActivityAsReviewed() {
      const payload = {
        ActivityId: this.activity.activityId,
      };
      doRequest(
        (response) => {
          this.$emit('reload');
          this.showReviewBox = false;
        },
        (error) => {},
        'markActivityAsReviewed',
        this.$store.getters['auth/userName'],
        payload,
        'POST',
        600000,
        false
      );
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.red {
  background: red;
}
.error-text {
  color: red;
  font-size: 14px;
}
.center-text {
  text-align: center;
}
.no-scroll {
  overflow: hidden !important;
}
a {
  text-decoration: inherit;
  color: inherit;
  cursor: auto;
}
.svg {
  position: absolute;
  width: 0;
  height: 0;
}
.clipped {
  width: 100%;
  background: #88d2fa;
  background-size: cover;
  border-radius: 15px;
  border: 1px solid lightgray;
  -webkit-clip-path: url(#my-clip-path);
  clip-path: url(#my-clip-path);
}
.shadow {
  filter: drop-shadow(2px 3px 2px rgba(0, 0, 0, 0.1));
}
.full-width {
  width: 100%;
}
</style>
